import { Component, OnDestroy } from '@angular/core'
import { Subject } from 'rxjs/Subject'
/**
 * Created by sange on 22/02/2017.
 */

@Component({
  template: ''
})
export class CommonComponent implements OnDestroy {

  /**
   * The way how to avoid memory leaks in case of using Observable::subscribe
   * - usage: a component extends this class and before every .subscribe calls .takeUntil(thi.ngUnsubscribe)
   * also extending cmp must call super.ngOnDestroy() when overriding ngOnDestroy method
   * - eg:
   *        Observable.takeUntil(thi.ngUnsubscribe)
   *                  .subscribe(...)
   *
   * @type {Subject<void>}
   */
  ngUnsubscribe = new Subject<void>()

  ngOnDestroy(): void {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/common.component.ts